export { default } from './WixStyleReactProvider.js';
